/* @flow */
import {padEnd, isFinite} from 'lodash';

const getCurrencySymbol = (currency: string): string => {
  switch (currency) {
    case 'USD':
      return '$';
    case 'GBP':
      return '£';
    case 'EUR':
      return '€';
    case 'CAD':
      return 'C$';
    default:
      return '$';
  }
};

const padCents = (cents: string = ''): string =>
  padEnd(cents, 2, '0').slice(0, 2);

const padPrice = (currency: string, price: number): string => {
  const [dollars, cents] = String(price).split('.');

  return `${getCurrencySymbol(currency)}${dollars}.${padCents(cents)}`;
};

export default (currency: string, price: ?number): string =>
  typeof price === 'number' && isFinite(price)
    ? padPrice(currency, price)
    : '';
